import React, {useState} from 'react'

function MobileFilter({openFilterHandleChange, closeFilterHandleChange, openFilterDrawer}) {


  return (
    <>
        <button className='bs-btn bs-btn__btn-icon-link lyt-product-list__filter-action' onClick={openFilterHandleChange}>
            <span className='bs-btn__icon icon icon-filter2'></span>
        </button>
    </>
  )
}

export default MobileFilter